import { useState, useRef } from "react";
import { FileDown, Paperclip, UploadCloud,Download } from "lucide-react"; // Usa 'lucide-react' para el ícono
import Tooltip from "../Elements/Tooltip";
import { iDatacenter, iDataCenterDoc, iProProjectMain } from "@/app/models/interfaceProject";
import { useUser } from "@/app/context/UserContext";
import * as XLSX from "xlsx";
import { getChangeName } from "@/app/helpers/functions";
import Loading from "../Elements/Loading";
import { getExcelReadColumns } from "@/app/helpers/excel";
import { chatbotDownloadFileDatacenter } from "@/app/services/charbotDownloadFileDatacenter";
import { DataCenterDoc, TypeFile } from "@/app/constants/enums";



interface DatacenterUploadProps {
    isOpen: boolean;
    onClose: () => void;
    onUpload: (data: iDataCenterDoc) => void;
}

export default function DatacenterUploadIndex() {
  const { user, setUser, 
          userLoading, setUserLoading,
          userLoaded, setUserLoaded,
          userProject,setUserProject,
          userProjectLoading, setUserProjectLoading,
          myDocs, setMyDocs,
          myDocsLoading, setMyDocsLoading } = useUser();// Accedemos al usuario logueado desde el contexto

  const [file, setFile] = useState<File | null>(null);
  const [error, setError] = useState<string | null>(null); 
  const fileInputRef = useRef<HTMLInputElement | null>(null); 
  const [loadingUpload, setLoadingUpload] = useState(false);

  const [fileDato, setFileDato] = useState<iDataCenterDoc | null>( ()=>{
    const firstDoc = userProject.index_docs?.[0];
      return !firstDoc?null: {
        deleted: firstDoc.deleted,
        file_id: firstDoc.file_id,
        file_url: firstDoc.file_url,
        name: firstDoc.name,
        file_id_local:crypto.randomUUID(),
        type:firstDoc.type??TypeFile.Excel,
      }; }
     );

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files?.[0]) {
      handleFile(event.target.files[0]);
    }
  };
 
  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
  };

  const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    if (event.dataTransfer.files.length > 0) {
      handleFile(event.dataTransfer.files[0]);
    }
  };
  
   
  const onDownload = (file: iDataCenterDoc) => {
      if (!file?.file_url) {
        console.warn("El archivo no tiene una URL válida:", file)
        return
      }

      const link = document.createElement("a")
      link.href = file.file_url
      link.download = file.name || "archivo"
      link.target = "_blank"
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

  const handleDownloadIndex = async (file: iDataCenterDoc) => {
        //console.log("Descargando archivo new:", file)
      if (!file.file_url) {
        console.warn("El archivo no tiene URL", file)
        return
      }
      if (!file.name){
        console.warn("El archivo no tiene nombre", file)
        return
      }
      await chatbotDownloadFileDatacenter(
        file.file_url,
        file.name,
        user,
        setUser
      )
  }
  const handleFile = async (selectedFile: File) => {
    if (!selectedFile) return;

    if (selectedFile.size > 30 * 1024 * 1024) {
      setError("El archivo supera el límite de 30MB");
      return;
    } 

    const validExtensions = [".xls", ".xlsx"];
    const fileExtension = selectedFile.name.split(".").pop()?.toLowerCase();
    if (!fileExtension || !validExtensions.includes(`.${fileExtension}`)) {
      setError("Solo se permiten archivos Excel (.xls, .xlsx)");
      return;
    } 
    setLoadingUpload(true);
    setFile(selectedFile); 
    setError(null); 
    const firstDoc = userProject.index_docs?.[0];
    const data: iDataCenterDoc = { 
      file_id_local:crypto.randomUUID() , 
      chunk_overlap: DataCenterDoc.chunk_overlap,
      chunk_size: DataCenterDoc.chunk_size,
      deleted: false,        
      file_type:selectedFile?.type,
      file_size: selectedFile?.size,
      type: (selectedFile?.name.endsWith(".pdf") || selectedFile?.name.endsWith(".PDF") )?TypeFile.Pdf:TypeFile.Excel ,
      name: selectedFile?.name,
      columns: await getExcelReadColumns(selectedFile), 
      file: selectedFile || null,
      actual_documents_file_id:firstDoc?.file_id
    }; 
    setFileDato( data ); 
    setUserProject((prevProject:iProProjectMain) => {
        const existingDatacenter = prevProject.datacenter; 
        // Si no hay datacenter, inicializarlo con valores predeterminados
        const newDatacenter: iDatacenter = existingDatacenter || {
          embedding: "",
          embedding_source: "",
          database_service: "",
          documents_file_flag:true,
          name: "Nuevo Datacenter",
          database_service_id: getChangeName(userProject,user),
          description: "",
          files: [], 
          documents_file: [],
          deleted_qa:false
        }; 
        return {
          ...prevProject,
          datacenter: {
            ...newDatacenter,
            //documents_file: [...newDatacenter.documents_file, data],
            documents_file: [data],
          },
        };
      });  
      setLoadingUpload(false);
  }; 

  const [loading, setLoading] = useState(false);
  const handleDownload = () => {
    setLoading(true);
    const filePath = "/files/Plantilla_Indexacion.xlsx";
    const link = document.createElement("a");
    link.href = filePath;
    link.download = "Plantilla_Indexacion.xlsx"; 
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setLoading(false);
  };


  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-lg font-bold">Cargar Archivo</h3>                 
      </div>


      <div className="flex justify-between items-center w-full py-2">
            <span className="mt-1 ">Descargar Plantilla</span>    
            <button                
              className="flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 transition-colors border border-gray-300 hover:bg-gray-200 btn-inca-secondary shadow-md"
              onClick={handleDownload} 
              disabled={loading}
            > 
                {loading ? <Loading w="w-2" h="h-2" className="" /> : <FileDown className="w-5 h-5 text-gray-700" strokeWidth={1.5} />}
            </button>
        </div>
    <div className="w-full">
        
        
      
    </div>

      <input
        id="fileInputId"
        ref={fileInputRef}
        type="file"
        className="hidden"
        accept=".xls,.xlsx"
        onChange={handleFileChange}
        disabled={loadingUpload} 
      /> 

      <div className="flex justify-center items-center w-full mt-5">
        <div
          className={`w-full flex flex-col justify-center items-center gap-4 border border-blue-300 n-fmr-input transition border-dashed rounded-3xl h-32 cursor-pointer
            ${loadingUpload ? "bg-gray-200 cursor-not-allowed" : "hover:bg-gray-100"}`}
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={() => !loadingUpload && fileInputRef.current?.click()} 
        >
          
          <UploadCloud className="w-20 h-20 text-blue-300 " />
          
          {loadingUpload ? (
            <Loading w="w-6" h="h-6" className="" /> /* Indicador de carga más grande */
          ) : (
            <span className="text-gray-700 font-medium">
              {fileDato?.name ? fileDato.name : "Seleccione un archivo Excel"}
            </span>
          )}
        </div>
      </div>

      <div className="text-rose-500"> {error&&error} </div>
      {fileDato && (
        <button
          type="button"
          onClick={() => handleDownloadIndex(fileDato)}
          className="btn-inca-secondary shadow-md rounded-full border border-gray-300 px-3 py-1 flex items-center gap-2 mt-4"
        >
          <span>Descargar actual</span>
          <Download className="w-4 h-4" strokeWidth={1.5} />
        </button>
      )}
    </div>
  );
}
